import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { TipoModalCarregando } from '../enum/tipo-modal-carregando.enum';

@Injectable({
    providedIn: 'root'
})
export class MensagemService {

    private loadingCmp: any;
    private toast: any;

    constructor(
        private toastCtrl: ToastController,
        private loadingCtrl: LoadingController
    ) {}

    async presentLoading(message = 'Carregando Dados', id?: any) {
        this.loadingCmp = await this.loadingCtrl.create({
            message,
            cssClass: 'spinner-loader',
            id: id ? id + '' : undefined,
        });
        return await this.loadingCmp.present();
    }

    async dismissLoading(): Promise<any> {
        let topLoader = await this.loadingCtrl.getTop();
        while (topLoader) {
            if (!(await topLoader.dismiss())) {
                return false;
            }
            topLoader = await this.loadingCtrl.getTop();

            if(!topLoader) {
                return false;
            }
        }
    }

    async dismissSpecificLoading(id?: string) {
        let topLoader = await this.loadingCtrl.getTop();
        if(!topLoader) { // valida o fato de dar um dismiss apenas quando tem pelo menos um loading na tela
            return;
        }
        await this.loadingCtrl.dismiss('','',id);
    }

    async showToast(mensagem: string | Error, duration = 8000) {
        this.fecharToast();
        if (!mensagem) {
            return;
        }
        let textoMensagem: string;
        if (mensagem instanceof Error) {
            textoMensagem = mensagem.message;
        } else {
            textoMensagem = mensagem;
        }
        this.toast = await this.toastCtrl.create({
            message: textoMensagem,
            duration,
            position: 'top',
            buttons: [
                {
                    text: 'X',
                    role: 'Dismiss'
                }
            ]
        });
        this.toast.present();
    }

    private async fecharToast() {
        if (this.toast) {
            await this.toast.dismiss();
            this.toast = null;
        }
    }
}
